import { DownArrowIcon } from "@xola/icons";
import React from "react";
import { SelectionState } from "types";
import { SecondaryButton } from "../Common/SecondaryButton";
import { SelectionWithName } from "../Dashboard/Filters/ListFilter";
import { RoundedCounter } from "./PurchaseProductImage";

export interface FilterButtonProps {
    label: string;
    value: SelectionState | SelectionWithName;
    onClick: () => void;
}

export const FilterButton = ({ label, value, onClick }: FilterButtonProps) => {
    return (
        <SecondaryButton className="items-center -space-x-1 font-normal" onClick={onClick}>
            <Content label={label} selection={value} />
            <DownArrowIcon size="tiny" />
        </SecondaryButton>
    );
};

interface ContentProps {
    label: string;
    selection: SelectionState | SelectionWithName;
}

const Content = ({ label, selection }: ContentProps) => {
    const count = selection.selected.length;

    return (
        <span className="flex items-center">
            {count > 0 && (
                <span className="relative -top-1.5 mr-5">
                    <RoundedCounter className="!z-0" count={count} />
                </span>
            )}

            <span className="mx-1">{label}</span>
        </span>
    );
};
